import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { AlignmentPositions, Popover } from '@guildeducationinc/recess';
import InfoOutlinedIcon from '@guildeducationinc/recess/icons/InfoOutlinedIcon';
import { snakeCase, uniqueId } from 'lodash';
import { useRef, useState } from 'react';
import { useLocale } from '../../hooks';
import { TrackableButton } from '../TrackableButton';
export const InfoPopover = ({ content, color }) => {
    const { t } = useLocale();
    const id = useRef(uniqueId('info-icon-')).current;
    const [show, setShow] = useState(false);
    const popoverContent = typeof content === 'string' ? content : () => _jsx(_Fragment, { children: content });
    const tag = typeof content === 'string' ? `info_${snakeCase(content)}` : `info_${id}`;
    return (_jsx(Popover, { id: id, show: show, popoverContent: popoverContent, triggerRefProp: 'forwardRef', onOutsideClick: () => setShow(false), preferredPositions: [AlignmentPositions.topMiddle], children: _jsx(TrackableButton, { btnType: 'icon', enText: 'More info', tag: tag, appearance: 'minimal', label: t('More info'), icon: _jsx(InfoOutlinedIcon, { color: color, size: 20 }), onClick: () => setShow(!show) }) }));
};
